module.exports = __webpack_public_path__ + "media/images/athletes/3128-b7cf0d3b983ae7ecdb6fbb1aaa65793d.png";